import React from 'react';
import type { ReactNode } from 'react';
import { cx } from '@milanote/roma/utils/cx';

const SEMANTIC_NAME = 'RomaFormText';

export type FormTextProps = {
    children: ReactNode;
    size?: 'sm' | 'md' | 'lg';
    color?: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'error';
    align?: 'left' | 'center' | 'right';
    className?: string;
};

const styles = {
    sizes: {
        sm: 'text-sm',
        md: 'text-md',
        lg: 'text-lg',
    },
    color: {
        primary: 'text-primary',
        secondary: 'text-secondary',
        tertiary: 'text-tertiary',
        quaternary: 'text-quaternary',
        error: 'text-error-primary font-medium',
    },
    align: {
        left: 'text-left',
        center: 'text-center',
        right: 'text-right',
    },
};

/**
 * Displays standardised text styling for form helpers and messages.
 */
export const FormText: React.FC<FormTextProps> = ({ children, size = 'md', color = 'secondary', align, className }) => {
    return (
        <p
            className={cx(
                SEMANTIC_NAME,
                styles.sizes[size],
                styles.color[color],
                align && styles.align[align],
                color === 'error' && 'data-[invalid=true]',
                // link styles
                '[&_a]:underline [&_a]:text-inherit [&_a]:decoration-current [&_a]:underline-offset-2 [&_a:hover]:text-tertiary_hover',
                // link outline for accessibility
                ' [&_a]:focus:outline-none [&_a]:focus:rounded-xxs [&_a]:focus:ring-2 [&_a]:focus:ring-offset-1 [&_a]:focus:ring-primary_focused',
                className,
            )}
        >
            {children}
        </p>
    );
};

FormText.displayName = SEMANTIC_NAME;
